import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useContact} from '../hooks/useContact';
import {Contact, ContactStatus} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useContact();

    return (
        <FormDrawer
            record={{
                id: '',
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                company: '',
                position: '',
                notes: '',
                status: ContactStatus.ACTIVE,
            } as Contact}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
